// `supa-base` é usado somente no cliente; importe dinamicamente para evitar
// inicializar o cliente no servidor.
import { logar } from "@/lib/auditoria";
import { nomeExib } from "@/lib/pessoas";
import { obterClienteDados } from "@/lib/obter-dados";
import { getSessionItem, setSessionItem } from "@/lib/storage-safe";

/**
 * Registra (uma única vez por sessão do navegador) o acesso do usuário ao
 * sistema e dispara o aviso importante (push no tópico ntfy).
 */
export async function registrarAcesso(userId: string, email: string) {
  if (typeof window === "undefined") return;
  const chave = `acesso-registrado:${userId}`;
  try {
    if (getSessionItem(chave)) return;
    setSessionItem(chave, "1");
  } catch {
    return;
  }
  const banco = await obterClienteDados();
  const { data: perfil } = await (banco as any)
    .from("profiles")
    .select("apelido, nome, email")
    .eq("id", userId)
    .maybeSingle();
  await logar("Novo acesso ao sistema", `${nomeExib(perfil, email)} entrou no aplicativo`, true, 1);
}
